export default (state, detailUserId = '') => ({ detailUserId });
